<template>
  <v-dialog v-model="open" transition="dialog-top-transition" max-width="400">
    <v-card>
      <v-card-title>Confirm</v-card-title>
      <v-card-text>
        Are you sure you want to delete this {{ item }}?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="remove"> Delete </v-btn>
        <v-btn text @click="open = false">Cancel </v-btn>
      </v-card-actions>
      <v-snackbar
        v-model="snackbar"
        color="info darken-1"
        :timeout="3000"
        light
        top
      >
        {{ snackbarMessage }}
        <v-btn text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>

<script>
import firebaseApp from "../../firebaseApp";

export default {
  data: () => ({
    open: false,
    snackbar: false,
    snackbarMessage: "",
  }),
  props: ["type", "item", "id", "message", "dialog"],
  watch: {
    dialog: function (newVal) {
      this.open = newVal == "open" ? true : false;
    },
  },
  methods: {
    remove() {
      firebaseApp
        .database()
        .ref(`/${this.type}/` + this.key)
        .remove()
        .then((this.snackbar = true), (this.snackbarMessage = this.message));
    },
  },
  mounted() {},
};
</script>